import './TopicPage.css';

function TopicPage({ title, subtitle, icon, color, sections }) {
  return (
    <div className="topic-page">
      <div className="topic-hero" style={{ '--accent': color }}>
        <div className="topic-hero-content">
          <span className="topic-hero-icon">{icon}</span>
          <h1 className="topic-title">{title}</h1>
          <p className="topic-subtitle">{subtitle}</p>
        </div>
        <div className="hero-glow" style={{ background: color }} />
      </div>

      <div className="topic-sections">
        {sections.map((section, i) => (
          <div className="topic-section" key={i}>
            <h2 className="section-title">
              <span className="section-icon">{section.icon}</span>
              {section.title}
            </h2>
            <div className="cards-grid">
              {section.cards.map((card, j) => (
                <div className="card" key={j} style={{ '--accent': color }}>
                  <div className="card-header">
                    <span className="card-icon">{card.icon}</span>
                    <h3 className="card-title">{card.title}</h3>
                    {card.level && (
                      <span className={`card-badge badge-${card.level}`}>
                        {card.level}
                      </span>
                    )}
                  </div>
                  <p className="card-desc">{card.description}</p>
                  {card.topics && (
                    <ul className="card-topics">
                      {card.topics.map((t, k) => (
                        <li key={k}>{t}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TopicPage;
